<template>
  <NavBar/>
  <div class="project_search">
    <van-icon name="search" size="58" color="#000" class="project_icon"/>
    <van-col :span="24" class="project_text">请先查询</van-col>
    <van-col :span="24" class="project_select">
      <van-field
        readonly
        clickable
        name="picker"
        v-model="regionName"
        placeholder="请选择小区"
        @click="showPicker = true"
      />
      <van-popup v-model:show="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
          value-key="name"
        />
      </van-popup>
    </van-col>
     <van-col :span="24" class="project_button">
       <div style="padding:10px">
        <van-button type="danger" size="normal" :disabled="!regionName" @click="searchList">立即查询</van-button>
       </div>
     </van-col>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading:false,
      finished: false,
      showPicker:false,
      columns:[{name:"我的小区",id:"123"},{name:"他的小区",id:"123"}],
      regionName:"",
      regionId:"",
    };
  },
  methods:{
    // 选择器确定后执行
    onConfirm(val){
      this.regionId = val.id;
      this.regionName = val.name;
      this.showPicker = false
    },
    // 立即查询---跳页
    searchList(){
      this.$router.push({
        path:"/ProjectList",
        query:{
          regionName:this.regionName
        }
      })
    }
  },
  mounted() {
  },
  created() {
  },
}
</script>
<style>
.project_icon{
  margin:30% auto 0;
  width: 100%;
  text-align: center;
  font-weight: bold;
}
.project_text{
  text-align: center;
  margin-top: 10px;
  font-size: 13px;
}
.project_select{
  margin-top: 30%;
}
.van-field{
  border-bottom: 1px solid #ccc;
}
.project_button{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.project_button .van-button{
  width: 100%;
}
.project_search{
  padding:0 10px;
  margin-top: 46px;
}
</style>